import styles from "./Insiders.module.scss";
import { FC } from "react";
import IndicatorBar from "@/components/indicator-bar/IndicatorBar";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { classNames, nFormatter } from "@/lib/utils";
import { isUndefined } from "lodash";
import { Box, Chip, useMediaQuery } from "@mui/material";

interface PropsTypes {
    valueSold: string | number;
    valueBought: string | number;
    oimBarPosition: number;
    overviewPage?: boolean;
}

const Insiders: FC<PropsTypes> = ({ valueSold, valueBought, oimBarPosition, overviewPage }) => {
    const isLargeScreen = useMediaQuery("(min-width: 2560px)");
    const isDesktop = useMediaQuery("(min-width:1920px)");
    const CHIP_STYLES = {
        width: "fit-content",
        fontWeight: "600",
        borderWidth: "2px",
        marginY: 0.25,
        "@media screen and (min-width: 768px)": {
            fontSize: "8px",
            "& .MuiChip-label": {
                padding: "0 4px",
            },
        },
        "@media screen and (min-width: 1920px)": {
            fontSize: "10px",
            "& .MuiChip-label": {
                padding: "6px",
            },
        },
    };

    return overviewPage ? (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
            <Box sx={{ marginLeft: 1, display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "flex-start", justifyContent: "space-around", height: "fit-content" }}>
                <Chip className={styles["overview-chip"]} clickable label={`${typeof valueSold === "number" ? nFormatter(valueSold, 2) : valueSold} SELL`} variant="outlined" color="error" sx={{ ...CHIP_STYLES }} size="small" />
                <Chip className={styles["overview-chip"]} clickable label={`${typeof valueBought === "number" ? nFormatter(valueBought, 2) : valueBought} BUY`} variant="outlined" color="primary" sx={{ ...CHIP_STYLES }} size="small" />
            </Box>
            <Box sx={{ width: "90%", marginX: "auto", height: "40%" }}>
                {!isUndefined(oimBarPosition) && <IndicatorBar title="Insider Momentum" percentage={oimBarPosition} bigFont={overviewPage} titleFont={isLargeScreen ? "13px" : isDesktop ? "11px" : "9px"} />}
            </Box>
        </Box>
    ) : (
        <div className={classNames(styles.Insiders, styles[overviewPage && "overview-page"])}>
            <Box className={styles["chip-container"]}>
                <Chip
                    className={styles.chip}
                    clickable
                    label={`${typeof valueSold === "number" ? nFormatter(valueSold, 2) : valueSold} SELL`}
                    variant="outlined"
                    color="error"
                    sx={{ mb: 1, width: "fit-content", fontWeight: "600", borderWidth: "2px" }}
                    size="small"
                />
                <Chip
                    className={styles.chip}
                    clickable
                    label={`${typeof valueBought === "number" ? nFormatter(valueBought, 2) : valueBought} BUY`}
                    variant="outlined"
                    color="primary"
                    sx={{ width: "fit-content", fontWeight: "600", borderWidth: "2px" }}
                    size="small"
                />
            </Box>

            {!isUndefined(oimBarPosition) && <IndicatorBar title="Insider Momentum" percentage={oimBarPosition} bigFont={overviewPage} />}
        </div>
    );
};

export default withStockStamp(Insiders, "oimBarPosition", { title: "Last 3 Months" }, "Insiders");
